import {useEffect, useState} from 'react';
import {usePageText} from '../context/page-text-context';
import {minutesLeftTo} from '../utils/dates';

const EnRouteTitle = ({repair}) => {
  const eta = repair.estimatedTechnicianArrivalTime;
  const {
    tracking: {techEnRoute},
  } = usePageText();
  const [timeLeft, setTimeLeft] = useState(calculateMinsLeft(eta));

  useEffect(() => {
    setTimeLeft(calculateMinsLeft(eta));
  }, [eta]);

  useEffect(() => {
    if (eta && timeLeft !== 0) {
      setTimeout(() => {
        setTimeLeft(calculateMinsLeft(eta));
      }, 60000);
    }
  }, [eta, timeLeft]);

  if (!eta) {
    return (
      <span className="title">
        {repair.technician.name} {techEnRoute.onWay}
      </span>
    );
  }

  if (timeLeft === 0) {
    return (
      <span className="title">
        {repair.technician.name} {techEnRoute.nearby}
      </span>
    );
  }

  return (
    <span className="title">
      {repair.technician.name} {techEnRoute.arriving}
      {timeLeft}
    </span>
  );
};

const calculateMinsLeft = (eta) => {
  var minutesLeft = minutesLeftTo(eta);
  if (minutesLeft <= 0) {
    return 0;
  }

  const hoursLeft = Math.floor(minutesLeft / 60);

  if (hoursLeft > 0) {
    minutesLeft = minutesLeft - hoursLeft * 60;
    return `${hoursLeft} ${pluralize('hour', hoursLeft)} and ${minutesLeft} ${pluralize('minute', minutesLeft)}`;
  }

  return `${minutesLeft} ${pluralize('minute', minutesLeft)}`;
};

const pluralize = (word, count) => (count > 1 ? `${word}s` : word);

export {EnRouteTitle};
